import { Articles } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function ProductPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Articles", href: "/articles" },
          { title: "Edit Article", href: `/articles/edit/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Edit Article</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Articles.Edit id={id} />
        </div>
      </div>
    </div>
  );
}
